import { Col, Container, Row, Tab } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import ProjectCards from "../Components/ProjectCards";
import "../styles/Projects.css";
import { H2 } from "../Components/Reusable";
import Carousel from "../Components/Carousel";
import { p_projects, c_projects } from "../Components/projects";
const Projects = () => {
 

  return (
    <section id="projects" className="project">
      <Container>
        <Row>
          <Col>
            <H2  data-aos="fade-up" data-aos-delay="100">Projects</H2>
            <p  data-aos="fade-up" data-aos-delay="200">
              Here's a list of <span>some</span> of the projects I've worked on
            </p>
            <Tab.Container id="projects-tabs" defaultActiveKey="one">
              <Nav
                variant="pills"
                defaultActiveKey="one"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
                data-aos="fade-in" data-aos-delay="300"
              >
                <Nav.Item>
                  <Nav.Link eventKey="one">Personal </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="two">Collaborated</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content className="content" data-aos="fade-left" data-aos-delay="400">
                <Tab.Pane eventKey="one">
                  <Carousel>
                    {p_projects.map((project, index) => {
                      return <ProjectCards key={index} {...project} />;
                    })}
                  </Carousel>
                </Tab.Pane>
                <Tab.Pane eventKey="two">
                <Carousel>
                    {c_projects.map((project, index) => {
                      return <ProjectCards key={index} {...project} />;
                    })}
                  </Carousel>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default Projects;
